module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAAT0lEQVQ4y82U2wkAIAwDAx2gI7l6R3IAIVrExwZN/u7vSB/gl45iCpy0evKx9LpRgWDZ0IACOVPqepZSmsWbXyl5FkRSgfYamxBJ3LTOr5uFhcq7ZJgtbAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNzowOSswOTowMLb14X8AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjIrMDk6MDA/qCjNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_00860_100x100.png
// module id = yPic
// module chunks = 0